import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './security/auth.guard';
import { RulesGuard } from './security/rules.guard';

const routes: Routes = [
  // Sem Auth e Rules
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'  // mantém aqui, mas revisa se está em ordem correta
  },
  {
    path: 'pagina-em-manutencao',
    loadChildren: () => import('./pages/pagina-em-manutencao/pagina-em-manutencao.module')
      .then(m => m.PaginaEmManutencaoModule)
  },
  {
    path: 'pagina-acesso-negado',
    loadChildren: () => import('./pages/pagina-acesso-negado/pagina-acesso-negado.module')
      .then(m => m.PaginaAcessoNegadoModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module')
      .then(m => m.LoginModule)
  },
  {
    path: 'esqueci-minha-senha',
    loadChildren: () => import('./pages/esqueci-minha-senha/esqueci-minha-senha.module')
      .then(m => m.EsqueciMinhaSenhaModule)
  },
  {
    path: 'cadastrar-senha/:token',
    loadChildren: () => import('./pages/cadastrar-senha/cadastrar-senha.module')
      .then(m => m.CadastrarSenhaModule)
  },
  {
    path: 'cadastrar-senha',
    loadChildren: () => import('./pages/cadastrar-senha/cadastrar-senha.module')
      .then(m => m.CadastrarSenhaModule)
  },
  // Com Auth e Rules Guards
  {
    path: '',
    canActivate: [AuthGuard],
    children: [

      {
        path: '',
        canActivate: [RulesGuard],
        loadChildren: () => import('./pages/chamados/chamados.module')
          .then(m => m.ChamadosModule)
      },
      {
        path: 'dashboard',
        canActivate: [RulesGuard],
        loadChildren: () => import('./pages/dashboard/dashboard.module')
          .then(m => m.DashboardModule),
      },
      {
        path: 'usuario-consulta',
        canActivate: [RulesGuard],
        loadChildren: () => import('./pages/usuario/usuario-consulta/usuario-consulta.module')
          .then(m => m.UsuarioConsultaModule)
      },
      {
        path: 'usuario-cadastro',
        canActivate: [RulesGuard],
        loadChildren: () => import('./pages/usuario/usuario-cadastro/usuario-cadastro.module')
          .then(m => m.UsuarioCadastroModule)
      },
      {
        path: 'usuario-cadastro/:id',
        canActivate: [RulesGuard],
        loadChildren: () => import('./pages/usuario/usuario-cadastro/usuario-cadastro.module')
          .then(m => m.UsuarioCadastroModule)
      },
      {
        path: 'perfil-consulta',
        canActivate: [RulesGuard],
        loadChildren: () => import('./pages/perfil/perfil-consulta/perfil-consulta.module')
          .then(m => m.PerfilConsultaModule)
      },
      {
        path: 'comunidade-associados-consulta',
        canActivate: [RulesGuard],
        loadChildren: () => import('./pages/foruns/comunidade-associados/comunidade-associados-consulta/comunidade-associados-consulta.module')
          .then(m => m.ComunidadeAssociadoConsultaModule)
      },
      {
        path: 'comunidade-associados-cadastrar',
        canActivate: [RulesGuard],
        loadChildren: () => import('./pages/foruns/comunidade-associados/comunidade-associados-cadastro/comunidade-associados-cadastrar.module')
          .then(m => m.ComunidadeAssociadoCadastrarModule)
      },
      {
        path: 'comunidade-associados-visualizar/:id',
        canActivate: [RulesGuard],
        loadChildren: () => import('./pages/foruns/comunidade-associados/comunidade-associados-visualizar/comunidade-associados-visualizar.module')
          .then(m => m.ComunidadeAssociadosVisualizarModule)
      },
      {
        path: 'comissoes-tecnicas-consulta',
        canActivate: [RulesGuard],
        loadChildren: () => import('./pages/foruns/comissoes-tecnicas/comissoes-tecnicas-consulta/comissoes-tecnicas-consulta.module')
          .then(m => m.ComissoesTecnicasConsultaModule)
      },
      {
        path: 'comissoes-tecnicas-visualizar/:id',
        canActivate: [RulesGuard],
        loadChildren: () => import('./pages/foruns/comissoes-tecnicas/comissoes-tecnicas-visualizar/comissoes-tecnicas-visualizar.module')
          .then(m => m.ComissoesTecnicasVisualizarModule)
      },
      {
        path: 'comissoes-tecnicas-cadastrar',
        canActivate: [RulesGuard],
        loadChildren: () => import('./pages/foruns/comissoes-tecnicas/comissoes-tecnicas-cadastro/comissoes-tecnicas-cadastrar.module')
          .then(m => m.ComissoesTecnicasCadastrarModule)
      },
      {
        path: 'grupos-trabalho-consulta',
        canActivate: [RulesGuard],
        loadChildren: () => import('./pages/foruns/grupos-trabalho/grupos-trabalho-consulta/grupo-trabalho-consulta.module')
          .then(m => m.GrupoTrabalhoConsultaModule)
      },
      {
        path: 'grupos-trabalho-cadastrar',
        canActivate: [RulesGuard],
        loadChildren: () => import('./pages/foruns/grupos-trabalho/grupos-trabalho-cadastro/grupos-trabalho-cadastrar.module')
          .then(m => m.GrupoTrabalhoCadastrarModule)
      },
      {
        path: 'grupos-trabalho-visualizar/:id',
        canActivate: [RulesGuard],
        loadChildren: () => import('./pages/foruns/grupos-trabalho/grupos-trabalho-visualizar/grupos-trabalho-visualizar.module')
          .then(m => m.GruposTrabalhoVisualizarModule)
      },
      {
        path: 'moderacao-aprovar-reprovar/:id',
        canActivate: [RulesGuard],
        loadChildren: () => import('./pages/foruns/moderacao/aprovar-reprovar/aprovar-reprovar.module')
          .then(m => m.AprovarReprovarModule)
      },
      {
        path: 'moderacao',
        canActivate: [RulesGuard],
        loadChildren: () => import('./pages/foruns/moderacao/moderar/moderar.module')
          .then(m => m.ModerarModule)
      },
      {
        path: 'minhas-postagens',
        canActivate: [RulesGuard],
        loadChildren: () => import('./pages/foruns/minhas-postagens/minhas-postagens.module')
          .then(m => m.MinhasPostagensModule)
      },
      {
        path: 'perfil-cadastro',
        canActivate: [RulesGuard],
        loadChildren: () => import('./pages/perfil/perfil-cadastro/perfil-cadastro.module')
          .then(m => m.PerfilCadastroModule)
      },
      {
        path: 'perfil-cadastro/:id',
        canActivate: [RulesGuard],
        loadChildren: () => import('./pages/perfil/perfil-cadastro/perfil-cadastro.module')
          .then(m => m.PerfilCadastroModule)
      },
      {
        path: 'ata-consulta',
        canActivate: [RulesGuard],
        loadChildren: () => import('./pages/avt-associados/atas/ata-consulta/ata-consulta.module')
          .then(m => m.AtaConsultaModule)
      },
      {
        path: 'ata-cadastro',
        canActivate: [RulesGuard],
        loadChildren: () => import('./pages/avt-associados/atas/ata-cadastro/ata-cadastro.module')
          .then(m => m.AtaCadastroModule)
      },
      {
        path: 'evento-consulta',
        canActivate: [RulesGuard],
        loadChildren: () => import('./pages/avt-associados/eventos/evento-consulta/evento-consulta.module')
          .then(m => m.EventoConsultaModule)
      },
      {
        path: 'evento-cadastro',
        canActivate: [RulesGuard],
        loadChildren: () => import('./pages/avt-associados/eventos/evento-cadastro/evento-cadastro.module')
          .then(m => m.EventoCadastroModule)
      },
      {
        path: 'evento-cadastro/:id',
        canActivate: [RulesGuard],
        loadChildren: () => import('./pages/avt-associados/eventos/evento-cadastro/evento-cadastro.module')
          .then(m => m.EventoCadastroModule)
      },
      {
        path: 'agenda-eventos',
        canActivate: [RulesGuard],
        loadChildren: () => import('./pages/agenda-eventos/agenda-eventos.module')
          .then(m => m.AgendaEventosModule)
      },
      {
        path: 'noticias',
        canActivate: [RulesGuard],
        loadChildren: () => import('./pages/avt-associados/noticias/noticia-consulta/noticia-consulta.module')
          .then(m => m.NoticiaConsultaModule)
      },
      {
        path: 'noticia/:id',
        canActivate: [RulesGuard],
        loadChildren: () => import('./pages/avt-associados/noticias/noticia-detalhes/noticia-detalhes.module')
          .then(m => m.NoticiaDetalhesModule)
      },
    ]
  },
  {
    path: '**',
    loadChildren: () =>
      import('./pages/pagina-nao-encontrada/pagina-nao-encontrada.module').then(
        (m) => m.PaginaNaoEncontradaModule
      ),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
